import React from "react";
import PropTypes from "prop-types";

const ExclamationIcon = ({ height = "12", width = "12", viewBox = "0 0 12 12" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none">
      <mask
        id="mask0_10403_1238"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="14"
      >
        <rect width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10403_1238)">
        <path
          d="M6.41675 9.9165H7.58342V6.4165H6.41675V9.9165ZM7.00008 5.24984C7.16536 5.24984 7.3039 5.19393 7.41571 5.08213C7.52751 4.97032 7.58342 4.83178 7.58342 4.6665C7.58342 4.50123 7.52751 4.36268 7.41571 4.25088C7.3039 4.13907 7.16536 4.08317 7.00008 4.08317C6.8348 4.08317 6.69626 4.13907 6.58446 4.25088C6.47265 4.36268 6.41675 4.50123 6.41675 4.6665C6.41675 4.83178 6.47265 4.97032 6.58446 5.08213C6.69626 5.19393 6.8348 5.24984 7.00008 5.24984ZM7.00008 12.8332C6.19314 12.8332 5.4348 12.68 4.72508 12.3738C4.01536 12.0675 3.398 11.6519 2.873 11.1269C2.348 10.6019 1.93237 9.98456 1.62612 9.27484C1.31987 8.56512 1.16675 7.80678 1.16675 6.99984C1.16675 6.19289 1.31987 5.43456 1.62612 4.72484C1.93237 4.01512 2.348 3.39775 2.873 2.87275C3.398 2.34775 4.01536 1.93213 4.72508 1.62588C5.4348 1.31963 6.19314 1.1665 7.00008 1.1665C7.80703 1.1665 8.56536 1.31963 9.27508 1.62588C9.9848 1.93213 10.6022 2.34775 11.1272 2.87275C11.6522 3.39775 12.0678 4.01512 12.374 4.72484C12.6803 5.43456 12.8334 6.19289 12.8334 6.99984C12.8334 7.80678 12.6803 8.56512 12.374 9.27484C12.0678 9.98456 11.6522 10.6019 11.1272 11.1269C10.6022 11.6519 9.9848 12.0675 9.27508 12.3738C8.56536 12.68 7.80703 12.8332 7.00008 12.8332ZM7.00008 11.6665C8.30286 11.6665 9.40633 11.2144 10.3105 10.3103C11.2147 9.40609 11.6667 8.30262 11.6667 6.99984C11.6667 5.69706 11.2147 4.59359 10.3105 3.68942C9.40633 2.78525 8.30286 2.33317 7.00008 2.33317C5.6973 2.33317 4.59383 2.78525 3.68967 3.68942C2.7855 4.59359 2.33341 5.69706 2.33341 6.99984C2.33341 8.30262 2.7855 9.40609 3.68967 10.3103C4.59383 11.2144 5.6973 11.6665 7.00008 11.6665Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

ExclamationIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  viewBox: PropTypes.string,
};

export default ExclamationIcon;
